// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-66d290c7] p:empty:before {\n  content: \" \";\n  white-space: pre;\n}\n[data-v-66d290c7] p:last-of-type {\n  margin-bottom: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
